<template>
  <v-card class="bundle-item-card">
    <v-img
      v-if="image"
      :src="image"
      height="200"
    />
    <div v-else class="bundle-item-card__placeholder">
      <v-icon size="40" color="grey lighten-1">
        mdi-image-off
      </v-icon>
    </div>
    <v-card-title>
      <div class="text-h4 mb-2">
        <span v-if="id" class="bundle-item-card__id">#{{ id }}</span>
        {{ name }}
      </div>
    </v-card-title>
    <v-card-text v-if="$slots.default">
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
  /**
   * Карточка блюда в составе набора: фото сверху, название, слот под селект модификаторов.
   */
  export default {
    name: 'BundleItemCard',
    props: {
      id: {
        type: Number,
        default: null,
      },
      name: {
        type: String,
        required: true,
      },
      image: {
        type: String,
        default: null,
      },
    },
  }
</script>

<style scoped lang="less">
.bundle-item-card {
  &__id {
    margin-right: 6px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    white-space: nowrap;
  }
  &__placeholder {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f0f0;
  }
}
</style>
